<script setup lang="ts">
import type { AlertDialogOverlayProps } from "reka-ui"
import type { HTMLAttributes } from "vue"
import { AlertDialogOverlay } from "reka-ui"
import { cn } from "@/shared/lib/utils"

const props = defineProps<
  AlertDialogOverlayProps & { class?: HTMLAttributes["class"] }
>()
</script>

<template>
  <AlertDialogOverlay
    data-slot="alert-dialog-overlay"
    :class="
      cn(
        // Scrim навмисно theme-independent (фіксований чорний з прозорістю) —
        // окремого `--overlay`-токена в DS немає (флагнуто в tech-036).
        'fixed inset-0 z-50 bg-black/50',
        props.class,
      )
    "
  >
    <slot />
  </AlertDialogOverlay>
</template>
